import DateRangePicker from '@/components/_partial/_atomic/DateRangePicker'

let dateRangePickerMixin = {
  components: { DateRangePicker }
}

export default dateRangePickerMixin
